module.exports = __webpack_public_path__ + "static/img/head1.7bcd3b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/head1.png
// module id = R2gL
// module chunks = 2